// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThreadSelector_canvasContainer__ANq60 {
  margin-right: 1em;
  flex-grow: 1;
  border-radius: 5px;
  /* border: 1px solid #d0d0d0; */
  /* height: 40em !important; */
  /* width: 100%; */
  max-width: 66%;
}
.ThreadSelector_canvas__UI6AR {
  border-radius: 5px;
}
.ThreadSelector_threadContainer__GMNKE {
  position: relative;
  /* flex-grow: 1; */
  width: 33%;
  /*min-width: 33%; */
}

.ThreadSelector_scrollContainer__IF4W3::-webkit-scrollbar {
  display: none;
}

@media only screen and (min-width: 600px) {
  .ThreadSelector_scrollContainer__IF4W3 {
    height: 100%;
    position: relative;
    overscroll-behavior: none;
    overflow-y: scroll;
    scrollbar-width: none;
  }
  .ThreadSelector_container__zsiPI {
    /* flex-direction: row; */
    /*height: 100%;*/
    /* width: 100%; */
    /* max-height: 40em; */
  }
}

@media only screen and (max-width: 600px) {
  .ThreadSelector_container__zsiPI {
    flex-direction: column;
  }
  .ThreadSelector_canvasContainer__ANq60 {
    margin-right: 0;
    /* flex-grow: 1; */
    /* border-radius: 5px;
      border: 1px solid #d0d0d0; */
    /* height: 80em !important; */
    max-width: 100%;
  }
  .ThreadSelector_threadContainer__GMNKE {
    position: relative;
    /* flex-grow: 1; */
    width: 100%;
    /*min-width: 33%; */
  }
  .ThreadSelector_scrollContainer__IF4W3 {
    height: 100%;
    position: relative;
  }
}

.ThreadSelector_container__zsiPI {
  display: flex;
  /* flex-direction: row; */
  height: 60vh;
  width: 100%;
}

.ThreadSelector_shadowContainer__BluoJ {
  position: absolute;
  right: 0;
  left: 0;
  pointer-events: none;
}

.ThreadSelector_shadowBottom__ucifP {
  transition: 300ms;
  height: 50%;
  bottom: 0;
  box-shadow: inset 0px -10px 10px -10px rgba(0, 0, 0, 0.75);
}
.ThreadSelector_shadowTop__vbWrF {
  transition: 300ms;
  box-shadow: inset 0px 10px 10px -10px rgba(0, 0, 0, 0.75);
  height: 50%;
  top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThreadSelector/ThreadSelector.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB;kCAC8B;IAC9B,6BAA6B;IAC7B,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EAET,0DAA0D;AAC5D;AACA;EACE,iBAAiB;EAEjB,yDAAyD;EACzD,WAAW;EACX,MAAM;AACR","sourcesContent":[".canvasContainer {\n  margin-right: 1em;\n  flex-grow: 1;\n  border-radius: 5px;\n  /* border: 1px solid #d0d0d0; */\n  /* height: 40em !important; */\n  /* width: 100%; */\n  max-width: 66%;\n}\n.canvas {\n  border-radius: 5px;\n}\n.threadContainer {\n  position: relative;\n  /* flex-grow: 1; */\n  width: 33%;\n  /*min-width: 33%; */\n}\n\n.scrollContainer::-webkit-scrollbar {\n  display: none;\n}\n\n@media only screen and (min-width: 600px) {\n  .scrollContainer {\n    height: 100%;\n    position: relative;\n    overscroll-behavior: none;\n    overflow-y: scroll;\n    scrollbar-width: none;\n  }\n  .container {\n    /* flex-direction: row; */\n    /*height: 100%;*/\n    /* width: 100%; */\n    /* max-height: 40em; */\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .container {\n    flex-direction: column;\n  }\n  .canvasContainer {\n    margin-right: 0;\n    /* flex-grow: 1; */\n    /* border-radius: 5px;\n      border: 1px solid #d0d0d0; */\n    /* height: 80em !important; */\n    max-width: 100%;\n  }\n  .threadContainer {\n    position: relative;\n    /* flex-grow: 1; */\n    width: 100%;\n    /*min-width: 33%; */\n  }\n  .scrollContainer {\n    height: 100%;\n    position: relative;\n  }\n}\n\n.container {\n  display: flex;\n  /* flex-direction: row; */\n  height: 60vh;\n  width: 100%;\n}\n\n.shadowContainer {\n  position: absolute;\n  right: 0;\n  left: 0;\n  pointer-events: none;\n}\n\n.shadowBottom {\n  transition: 300ms;\n  height: 50%;\n  bottom: 0;\n  -webkit-box-shadow: inset 0px -10px 10px -10px rgba(0, 0, 0, 0.75);\n  box-shadow: inset 0px -10px 10px -10px rgba(0, 0, 0, 0.75);\n}\n.shadowTop {\n  transition: 300ms;\n  -webkit-box-shadow: inset 0px 10px 10px -10px rgba(0, 0, 0, 0.75);\n  box-shadow: inset 0px 10px 10px -10px rgba(0, 0, 0, 0.75);\n  height: 50%;\n  top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"canvasContainer": `ThreadSelector_canvasContainer__ANq60`,
	"canvas": `ThreadSelector_canvas__UI6AR`,
	"threadContainer": `ThreadSelector_threadContainer__GMNKE`,
	"scrollContainer": `ThreadSelector_scrollContainer__IF4W3`,
	"container": `ThreadSelector_container__zsiPI`,
	"shadowContainer": `ThreadSelector_shadowContainer__BluoJ`,
	"shadowBottom": `ThreadSelector_shadowBottom__ucifP`,
	"shadowTop": `ThreadSelector_shadowTop__vbWrF`
};
export default ___CSS_LOADER_EXPORT___;
